import {useLocation} from 'react-router-dom';

const useUrlType = () => {
  const location = useLocation();

  // Check if the current URL includes "patient" or "poa"
  const isPatient = location.pathname.includes('patient');
  const isPOA = location.pathname.includes('poa');

  return { isPatient, isPOA };
};

export default useUrlType;